import axios from 'axios'
import { ERR_OK, BASE_URL } from "@/common/const";

axios.defaults.baseURL = BASE_URL;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

/*
* params 必须是一个对象
* */
export function get(url, params) {
    // 如果不是一个对象就包一下
    if (!(typeof params == 'object')) {
        params = { params }
    }
    return axios.get(url, {
        params: params
    }).then((res) => {
        const serverData = res.data;
        if (serverData.code === ERR_OK) {
            return serverData.data
        } else {
            console.log(serverData.msg);
            return false;
        }
    }).catch((e) => {
        console.log(e)
    })
}

/*
* params 必须是一个对象
* */
export function post(url, params) {
    // 如果不是一个对象就包一下
    if (!(typeof params == 'object')) {
        params = { params }
    }
    return axios.post(url, params).then((res) => {
        const serverData = res.data;
        // console.log(serverData)
        if (serverData.code === ERR_OK) {
            return serverData.data
        } else {
            window.alert(serverData.msg)
        }
    }).catch((e) => {
        console.log(e)
    })
}
